import { SegmentedControl } from './SegmentedControl';
import { TREND_RANGE_KEYS, type TrendRange } from './trendRanges';

// One control for the whole Trends page — every card moves together, unlike
// the per-card Chart/Grid toggle. The group label differs from the cards'
// "View" so queries for one never pick up the other.
export function TrendRangeSelector({ value, onChange }: { value: TrendRange; onChange: (v: TrendRange) => void }) {
  return <SegmentedControl options={TREND_RANGE_KEYS} value={value} onChange={onChange} label="Time range" />;
}
